var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/File/Excel/"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 4.16699C3.33325 2.78628 4.45254 1.66699 5.83325 1.66699H10.6311C11.2941 1.66699 11.93 1.93038 12.3988 2.39923L15.9344 5.93476C16.4032 6.4036 16.6666 7.03949 16.6666 7.70253V15.8337C16.6666 17.2144 15.5473 18.3337 14.1666 18.3337H5.83325C4.45254 18.3337 3.33325 17.2144 3.33325 15.8337V4.16699ZM14.1666 17.3337H5.83325C5.00482 17.3337 4.33325 16.6621 4.33325 15.8337V4.16699C4.33325 3.33856 5.00482 2.66699 5.83325 2.66699H10.6311C10.6708 2.66699 10.7105 2.66857 10.7498 2.6717V5.83366C10.7498 6.80016 11.5333 7.58366 12.4998 7.58366H15.6619C15.665 7.62306 15.6666 7.66271 15.6666 7.70253V15.8337C15.6666 16.6621 14.995 17.3337 14.1666 17.3337ZM15.169 6.58366L11.7498 3.16446V5.83366C11.7498 6.24787 12.0856 6.58366 12.4998 6.58366H15.169Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    d: "M11.0416 11.9485C10.9967 12.0146 10.9967 12.1015 11.0416 12.1676L12.7207 14.6445C12.8085 14.774 12.716 14.9491 12.5599 14.9491H11.3502C11.2858 14.9491 11.2256 14.9171 11.1894 14.8637L10.2882 13.5341C10.211 13.4203 10.0437 13.4203 9.96652 13.5341L9.06529 14.8637C9.02909 14.9171 8.96886 14.9491 8.90446 14.9491H7.69478C7.53869 14.9491 7.44622 14.774 7.53396 14.6445L9.21312 12.1676C9.25795 12.1015 9.25795 12.0146 9.21312 11.9485L7.53396 9.4715C7.44622 9.34208 7.53869 9.16699 7.69478 9.16699H8.90446C8.96886 9.16699 9.02909 9.19896 9.06529 9.25237L9.96652 10.5819C10.0437 10.6958 10.211 10.6958 10.2882 10.5819L11.1894 9.25237C11.2256 9.19896 11.2858 9.16699 11.3502 9.16699H12.5599C12.716 9.16699 12.8085 9.34208 12.7207 9.4715L11.0416 11.9485Z",
    fill: "#5B5C5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFile);
export default __webpack_public_path__ + "static/media/excelFile.07a2db696e8a3da22df34c75693d3528.svg";
export { ForwardRef as ReactComponent };